import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import React from 'react';
import Collapsible, { CollapsibleProps } from 'react-collapsible';

interface PrimeCollapsibleProps extends CollapsibleProps {
    renderAccordionTags?: boolean | null;
    accordionClassName?: string | null;
    renderSelfAccordionArrows?: boolean | null;
}

const PrimeCollapsible: React.FC<PrimeCollapsibleProps> = (props) => {
    const { renderAccordionTags, accordionClassName, renderSelfAccordionArrows, ...collapsibleProps } = props;
    const newProps: CollapsibleProps = {
        ...collapsibleProps,
        trigger: (
            <a href="#" className={classNames({ 'prime-collapsible-trigger': true, 'accordion-title': renderAccordionTags })} aria-expanded="false">
                {renderSelfAccordionArrows && <div className="prime-collapsible-icon"><FontAwesomeIcon icon={faChevronDown} /></div>}
                {props.trigger}
            </a>
        ),
        triggerWhenOpen: (
            <a href="#" className={classNames({ 'prime-collapsible-trigger': true, 'accordion-title': renderAccordionTags, 'is-open': true })} aria-expanded="true">
                {renderSelfAccordionArrows && <div className="prime-collapsible-icon"><FontAwesomeIcon icon={faChevronUp} /></div>}
                {props.triggerWhenOpen ? props.triggerWhenOpen : props.trigger}
            </a>
        ),
    };
    const content = (
        <Collapsible {...newProps}>
            {renderAccordionTags ? <div className={'accordion-content'} style={{ display: 'block' }}>{props.children}</div> : props.children}
        </Collapsible>);
    return (
        <div className={'prime-collapsible'}>
            {renderAccordionTags === true ? (
                <ul className={classNames(['accordion', props.accordionClassName])}>
                    <li className={'accordion-item'}>{content}</li>
                </ul>) : content}
        </div>
    );
};

export default PrimeCollapsible;
